// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This replaces BaseNotary class with a factory function that uses BaseApiServiceFactory

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";

export interface IBaseNotary extends IBaseApiService {
	namespaceUrl: string;
}

export function createBaseNotary(): IBaseNotary {
	const baseApi = createBaseApiService();

	return {
		...baseApi,
		get namespaceUrl(): string {
			return baseApi.getBaseUrl().concat("/notary");
		},
	};
}
